import React, { useEffect, useState } from 'react';
import SmallIconButton from 'components/atoms/Button/SmallIconButton';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import {
  selectChat,
  setCurrentIndex,
  updateLastMessage,
} from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';
import { useDispatch } from 'react-redux';
import {
  Body,
  CommentBox,
  CommentSection,
  CommentText,
  DetailSection,
  NameSection,
  NameText,
  spanStyle,
  UserSection,
  WhiteCommentText,
} from './styles';
import { getRef } from 'utils/Firebase.util';
import { selectAuth } from 'features/auth/authSlice';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from 'app/firebase';
import moment from 'moment';

export interface inboxListsProps {
  data: UserData;
  selected?: boolean;
  avatar?: string;
  id?: number;
  role?: string;
  verified: boolean;
}

const InboxLists: React.FC<inboxListsProps> = ({
  verified,
  role,
  selected,
  avatar,
  id,
  data,
}) => {
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const verifySvg = require('assets/icons/verify.svg');

  const history = useNavigate();
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const [lastMessage, setLastMessage] = useState<{
    text: string;
    isRead: boolean;
    uid: number;
    date: string;
    type?: string;
  }>({ text: '', isRead: false, uid: -1, date: '' });

  const navigateToChat = () => {
    const currentIndex = chatState.inboxUsers.findIndex(
      user => user.user.id === data?.id
    );
    dispatch(setCurrentIndex(currentIndex));
    dispatch(updateLastMessage());
    history('/dm', { state: { data: data } });
  };

  useEffect(() => {
    const getLastMsg = async () => {
      if (authState.id && data) {
        const docRef = await getRef(authState.id, data.id);
        if (docRef) {
          const q = query(
            collection(db, 'chats', docRef, 'messages'),
            orderBy('date', 'desc'),
            limit(1)
          );
          const docs = await getDocs(q);
          if (docs.docs[0].exists()) {
            handleSetLastMessage(docs.docs[0].data());
          }
        }
      }
    };
    getLastMsg();
  }, [authState.id, data, chatState.currentIndex]);

  const handleSetLastMessage = (data: any) => {
    const seconds = data.date;
    setLastMessage({
      text: data.text,
      isRead: data.isRead || false,
      uid: data.uid,
      date: moment(seconds.toDate()).fromNow(),
      type: data.type,
    });
  };

  const getTypeMessage = (type: string) => {
    switch (type) {
      case 'image':
        return 'sent an image';
      case 'video':
        return 'sent a video';
      case 'nft':
        return 'sent an NFT';
      default:
        return 'sent an invite';
    }
  };

  const getText = (): string => {
    if (chatState.inboxUsers[chatState.currentIndex].user.id === data.id) {
      if (chatState.lastMessage) {
        if (chatState.lastMessage.type) {
          return getTypeMessage(chatState.lastMessage.type);
        } else {
          return chatState.lastMessage.text || '';
        }
      } else {
        if (lastMessage.type) {
          return getTypeMessage(lastMessage.type);
        } else {
          return lastMessage.text || '';
        }
      }
    } else {
      if (lastMessage.type) {
        return getTypeMessage(lastMessage.type);
      } else {
        return lastMessage.text || '';
      }
    }
  };

  return (
    <Body
      onClick={navigateToChat}
      style={{
        position: 'relative',
        backgroundColor: `${selected ? 'rgba(255,255,255,.1)' : ''}`,
        cursor: 'pointer',
      }}
    >
      <UserSection>
        <div style={{ position: 'relative' }}>
          <img
            src={avatar ? avatar : data?.avatar ? data.avatar : user0}
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
            alt={'user'}
          />
          <span
            style={{
              ...spanStyle,
              backgroundColor: chatState.onlineUsers.includes(data.id)
                ? 'lightgreen'
                : 'lightgray',
            }}
          ></span>
        </div>
        <DetailSection>
          <NameSection>
            <NameText>{data.name}</NameText>
            {role ? (
              <SmallIconButton
                text={role}
                color={'yellow'}
                isClicked={true}
                type={'dev'}
              />
            ) : (
              <></>
            )}
            {verified ? (
              <img src={verifySvg.default} alt="" width="21px" height="21px" />
            ) : (
              <></>
            )}
            <CommentText style={{ marginLeft: '10px' }}>
              <span>{lastMessage.date}</span>
            </CommentText>
          </NameSection>
          <CommentSection>
            {lastMessage.uid === authState.id || lastMessage.isRead ? (
              <>
                <CommentBox>
                  {/* <CommentBox> */}
                  <CommentText>{getText()}</CommentText>
                </CommentBox>
              </>
            ) : (
              <>
                <CommentBox>
                  <WhiteCommentText>{getText()}</WhiteCommentText>
                </CommentBox>
                <WhiteCommentText style={{ marginLeft: '5px' }}>
                  <span>{lastMessage.date}</span>
                </WhiteCommentText>
              </>
            )}
          </CommentSection>
        </DetailSection>
      </UserSection>
    </Body>
  );
};

export default InboxLists;
